import React, { useEffect, useRef, useState, useLayoutEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const Hero = ({ onOpenExplorer }) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  const videoRef = useRef(null);
  const sectionRef = useRef(null);

  useLayoutEffect(() => {
    setIsDesktop(window.innerWidth >= 1024);
  }, []);

  useEffect(() => {
    const checkDesktop = () => setIsDesktop(window.innerWidth >= 1024);
    window.addEventListener('resize', checkDesktop);
    return () => window.removeEventListener('resize', checkDesktop);
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    video.play().catch(() => {});
    const onData = () => video.play().catch(() => {});
    video.addEventListener('loadeddata', onData);
    return () => video.removeEventListener('loadeddata', onData);
  }, [isDesktop]);

  const scrollToGallery = () => {
    document.getElementById('galerie')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      ref={sectionRef}
      id="hero" 
      className="relative w-full h-screen overflow-hidden"
    >
      {/* BACKGROUND LAYER */}
      <div className="absolute inset-0 w-full h-full bg-[#1a1510]">
        
        <video
          ref={videoRef}
          className="w-full h-full object-cover"
          style={{ objectPosition: isDesktop ? 'center 30%' : 'center center' }}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          poster={isDesktop ? "/hero-desktop-poster.jpg" : "/hero-mobile-poster.jpg"}
          fetchpriority="high"
          data-testid="hero-video"
        >
          <source src={isDesktop ? "/hero-desktop-fast.mp4" : "/hero-mobile-fast.mp4"} type="video/mp4" />
        </video>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToGallery}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white hover:text-[#d4af37] transition-colors animate-bounce cursor-pointer z-10"
        aria-label="Scroll to gallery"
      >
        <ChevronDown size={48} className="drop-shadow-lg" />
      </button>
    </section>
  );
};

export default Hero;
